import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { appModernizationDetails } from '../../config';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs/operators';
import { SharedAuthService } from '../../shared/shared.auth.service';

@Injectable({
  providedIn: 'root'
})
export class BulkImportService {
  private apiUrl: string;
  private config: any;
  private largeApiUrl: string = environment.LargeapiUrl;

  private userDtls: any;
  constructor(private http: HttpClient, private sharedAuthService: SharedAuthService) {
    this.config = appModernizationDetails;
    this.apiUrl = environment.apiUrl;
    const currentUser = sessionStorage.getItem('currentUser') || '';
    this.userDtls = {
      cn: this.sharedAuthService.getMsid(),
      mail: sessionStorage.getItem('loggedInUserEmail') || '',
      givenName: currentUser ? currentUser.trim().split(',')[1].trim() : '',
      sn: currentUser ? currentUser.trim().split(',')[0].trim() : '',
    }
  }


  public ImportFile(body, uploadType): Observable<any> {
    let url;
    if (uploadType === 'Capability_Mapping') {
      url = this.apiUrl + this.config.routerpath.businessSupportBulkImport;
    }
    else if ((uploadType === 'LOB_Update')) {
      url = this.apiUrl + this.config.routerpath.businessLobSublobBulkImportPreview;
    } else if ((uploadType === 'Padu_Update')) {
     
      body['userDetails'] = this.userDtls;
      url = this.largeApiUrl + this.config.routerpath.paduRoadmapBulkImport;
    } else if ((uploadType === 'Padu_Save')) {
     
      body['userDetails'] = this.userDtls;
      url = this.largeApiUrl + this.config.routerpath.paduRoadmapBulkSave;
    }
    else if ((uploadType === 'primary_Update')) {
      url = this.apiUrl + this.config.routerpath.primaryUploadBulkImport;
    } else if ((uploadType === 'primary_Save')) {
      url = this.apiUrl + this.config.routerpath.primaryUploadBulkImportUpdate;
    }
    else if (uploadType === 'Edit_Model') {
      url = this.apiUrl + this.config.routerpath.editModelBulkImport;
    }
    else if (uploadType === 'LOB_Save') {
      url = this.apiUrl + this.config.routerpath.businessLobSublobBulkImport;
    }
    else {
      url = this.apiUrl + this.config.routerpath.bulkImport;
    }

    const headers = new HttpHeaders({
      'Content-Type': ''
    });
    const options = {
      headers: headers
    };
    return this.http.put<any>(url, body, options).pipe(
      map(data => { return data; }));
  }
}
